import { useEffect } from 'react';
import { usePrevious } from 'react-use';

import { useAppointmentStatus } from './useAppointmentStatus';
import { SUMMARY_TAB, useAppointmentTabNav } from './useAppointmentTabNav';

export const useListenForAppointmentEnd = () => {
  const { setTab } = useAppointmentTabNav();
  const appointmentStatus = useAppointmentStatus();
  const prevAppointmentStatus = usePrevious(appointmentStatus);

  useEffect(() => {
    if (
      prevAppointmentStatus === 'ACTIVE' &&
      appointmentStatus === 'COMPLETED'
    ) {
      setTab(SUMMARY_TAB);
    }
  }, [appointmentStatus, prevAppointmentStatus, setTab]);
};
